module.exports = __webpack_public_path__ + "img/service-01.c43040f5.webp";